const commentItems = [
  {
    name: '吃瓜一线战士',
    time: '2小时前',
    avatar: '瓜',
    content: '这个平台的更新速度真的快！刚在微博上看到热搜，这边已经有视频了，太给力了！每天不看两眼都感觉跟不上节奏。',
    likes: 1283,
  },
  {
    name: '八卦小能手',
    time: '5小时前',
    avatar: '八',
    content: '画质确实不错，1080P看着很舒服。而且不用注册就能看，这点对懒人太友好了，已经推荐给好几个朋友了。',
    likes: 967,
  },
  {
    name: '深夜吃瓜人',
    time: '8小时前',
    avatar: '深',
    content: '内容分类很全，娱乐圈、网红圈、社会热点都有，想看什么类型的瓜都能找到。希望能一直保持这个更新频率。',
    likes: 754,
  },
  {
    name: '理性吃瓜群众',
    time: '12小时前',
    avatar: '理',
    content: '作为老用户想说，平台内容确实丰富，但建议大家理性吃瓜，不要轻信未经证实的信息。整体体验还是很好的。',
    likes: 621,
  },
  {
    name: '追瓜达人',
    time: '1天前',
    avatar: '追',
    content: '手机端浏览体验很棒！通勤路上刷刷最新爆料，高清不卡顿。已经成了我每天的必修课了，比刷短视频还上瘾。',
    likes: 489,
  },
];

const indexItems = [
  { title: '娱乐圈八卦', count: '1.2万+', icon: 'ri-star-line', color: 'bg-primary-100 text-primary-600' },
  { title: '网红爆料', count: '9,800+', icon: 'ri-user-smile-line', color: 'bg-accent-100 text-accent-600' },
  { title: '社会热点', count: '1.5万+', icon: 'ri-fire-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '明星动态', count: '8,200+', icon: 'ri-vip-crown-line', color: 'bg-primary-100 text-primary-600' },
  { title: '综艺名场面', count: '1.1万+', icon: 'ri-tv-line', color: 'bg-accent-100 text-accent-600' },
  { title: '影视剧透', count: '6,500+', icon: 'ri-film-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '情感八卦', count: '7,800+', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600' },
  { title: '直播名场面', count: '5,400+', icon: 'ri-live-line', color: 'bg-accent-100 text-accent-600' },
];

export function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">瓜友热评</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">吃瓜群众都在说什么</p>
        <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((item) => (
            <div
              key={item.name}
              className="bg-background-50 border border-background-200/60 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 text-white flex items-center justify-center text-sm md:text-base font-bold shrink-0">
                  {item.avatar}
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.content}</p>
              <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">分类索引</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">按分类快速找到你想看的吃瓜内容</p>
        <div className="mt-6 md:mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="flex items-center gap-3 p-3 md:p-4 bg-background-100 border border-background-200/60 rounded-lg transition-all hover:border-primary-200 hover:bg-background-200/50 cursor-pointer"
            >
              <span className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </span>
              <div className="min-w-0">
                <div className="text-xs md:text-sm font-bold text-foreground-800 whitespace-nowrap">{item.title}</div>
                <div className="text-[10px] md:text-xs text-foreground-400 mt-0.5">{item.count} 条内容</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}